<template>
  <rj-tabs v-model="tabsActive" class="custom-tab">
    <rj-tab-pane name="1">
      <span slot="label">待审批下单合同(<span class="tabNameTip">{{ nums.submit }}</span>)</span>
      <Approval-list @totalNumber="totalNumber" />
    </rj-tab-pane>
    <rj-tab-pane name="2">
      <span slot="label">我创建的下单合同</span>
      <my-creat-list />
    </rj-tab-pane>
    <rj-tab-pane name="3">
      <span slot="label">审批过的下单合同</span>
      <Approved-list />
    </rj-tab-pane>
    <rj-tab-pane name="4">
      <span slot="label">待审批分批发货</span>
      <watiApply />
    </rj-tab-pane>
    <rj-tab-pane name="5">
      <span slot="label">已审批分批发货</span>
      <readyApply />
    </rj-tab-pane>
    <rj-tab-pane name="6">
      <span slot="label">待审批退换货合同</span>
      <watiApplyReturnExchange />
    </rj-tab-pane>
    <rj-tab-pane name="7">
      <span slot="label">审批过的退换货合同</span>
      <readyApplyReturnExchange />
    </rj-tab-pane>
    <rj-tab-pane name="8">
      <span slot="label">国际待审核发货单</span>
      <InternationalDeliveryOrderToBeReviewed />
    </rj-tab-pane>
    <rj-tab-pane name="9">
      <span slot="label">国际已审核发货单</span>
      <InternationalInvoiceHasBeenReviewed />
    </rj-tab-pane>
    <rj-tab-pane name="10">
      <span slot="label">待审批国际退换货</span>
      <watiApplyInterReturnExchange />
    </rj-tab-pane>
    <rj-tab-pane name="11">
      <span slot="label">已审批国际退换货</span>
      <approvedInterReturnExchange />
    </rj-tab-pane>
    <rj-tab-pane name="12">
      <span slot="label">资料上传</span>
      <UploadIncomeConfirmation />
    </rj-tab-pane>
    <template slot="tip">
      <el-dropdown size="small">
        <el-button type="primary">
          创建合同<i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="$router.push({name:'orderPersionContractCreatDomestic'})">
            创建国内合同
          </el-dropdown-item>
          <el-dropdown-item @click.native="$router.push({name:'orderPersionContractCreatInternational'})">
            创建国际合同
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </rj-tabs>
</template>
<script type="es6">
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import ApprovalList from './ApprovalList';
import ApprovedList from './ApprovedList';
import readyApply from './readyApply';
import watiApply from './watiApply';
import watiApplyReturnExchange from './watiApplyReturnExchange';
import readyApplyReturnExchange from './readyApplyReturnExchange';
import myCreatList from './myCreatList';
import UploadIncomeConfirmation from './UploadIncomeConfirmation.vue';
import InternationalDeliveryOrderToBeReviewed from '@/views/orderPersion/contract/InternationalDeliveryOrderToBeReviewed.vue';
import InternationalInvoiceHasBeenReviewed from '@/views/orderPersion/contract/InternationalInvoiceHasBeenReviewed.vue';
import watiApplyInterReturnExchange from '@/views/orderPersion/contract/watiApplyInterReturnExchange.vue';
import approvedInterReturnExchange from './approvedInterReturnExchange.vue';

export default {
  data () {
    return {
      nums: {
        submit: 0
      }
    };
  },
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    ApprovalList,
    ApprovedList,
    myCreatList,
    watiApply,
    readyApply,
    watiApplyReturnExchange,
    readyApplyReturnExchange,
    UploadIncomeConfirmation,
    InternationalInvoiceHasBeenReviewed,
    InternationalDeliveryOrderToBeReviewed,
    watiApplyInterReturnExchange,
    approvedInterReturnExchange
  },
  computed: {
    tabsActive: {
      get () {
        return this.$store.state.pagesTemporary.OrderPersionContractListTabActive;
      },
      set (val) {
        this.$store.commit('pagesTemporary/SETOrderPersionContractListTabActive', val);
      }
    }
  },
  methods: {
    totalNumber (val) {
      this.nums.submit = val;
    }
  },
  mounted () {

  }
};
</script>

<style lang="scss" scoped>
.custom-tab {
  ::v-deep .rj-tabs-names {
    &::-webkit-scrollbar {
      height: 7px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(140, 140, 138, 1) !important;
    }
  }
}
</style>
